import script from "./AdminVoonixAdvertisersTable.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminVoonixAdvertisersTable.vue?vue&type=script&setup=true&lang=js"

import "./AdminVoonixAdvertisersTable.vue?vue&type=style&index=0&id=631ce584&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-631ce584"]])

export default __exports__